import React, { useState, useEffect } from "react";
import { Slider, Handles, Tracks, Rail, Ticks, SliderItem } from "react-compound-slider";
import MtiSliderRail from "../Controls/MtiSliderRail";
import { MtiSliderHandle } from "../Controls/MtiSliderHandle";
import { MtiSliderTrack } from "../Controls/MtiSliderTrack";

type TickProps = { tick: SliderItem; count: number; labels: { [index: number]: string } };

function Tick({ tick, count, labels }: TickProps) {
  return (
    <div>
      <div
        style={{
          position: "absolute",
          marginTop: 14,
          fontSize: 12,
          textAlign: "center",
          marginLeft: `${-(100 / count) / 2}%`,
          width: `${100 / count}%`,
          left: `${tick.percent}%`,
          lineHeight: "14px",
          color: "#4F4F4F",
        }}
      >
        {labels[tick.value]}
      </div>
    </div>
  );
}

type Props = {
  disabled?: boolean;
  value: number;
  onValueChanged: (value: number) => void;
  style?: React.CSSProperties;
};

export default function ImagingArmSpeedSlider({ disabled = false, value, onValueChanged, style = {} }: Props) {
  const domain: [number, number] = [1, 5];
  const [innerValues, setInnerValues] = useState(value);

  useEffect(() => {
    setInnerValues(value);
  }, [value]);

  const onChangeSlider = (values: readonly number[]) => {
    if (disabled) {
      return;
    }
    onValueChanged(values[0]);
    setInnerValues(values[0]);
  };

  const onUpdateSlider = (values: readonly number[]) => {
    if (disabled) {
      return;
    }

    setInnerValues(values[0]);
  };

  const tickLabels = {
    [domain[0]]: "Slow",
    [domain[1]]: "Fast",
  };
  return (
    <div
      style={{
        minHeight: 40,
        // border: "1px solid black",
        ...style,
      }}
    >
      <Slider
        disabled={disabled}
        rootStyle={{
          position: "relative",
          top: 12,
          left: 12,
          width: "calc(100% - 24px)",
          height: 24,
        }}
        domain={domain}
        step={1}
        mode={1}
        values={[innerValues]}
        onUpdate={onUpdateSlider}
        onChange={onChangeSlider}
      >
        <Rail>{({ getRailProps }) => <MtiSliderRail getRailProps={getRailProps} />}</Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <MtiSliderHandle key={handle.id} handle={handle} domain={domain} getHandleProps={getHandleProps} />
              ))}
            </div>
          )}
        </Handles>
        <Tracks right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <MtiSliderTrack key={id} source={source} target={target} getTrackProps={getTrackProps} />
              ))}
            </div>
          )}
        </Tracks>
        <Ticks count={domain[1] - domain[0] + 1}>
          {({ ticks }) => (
            <div className="slider-ticks">
              {ticks.map((tick, index) => (
                <Tick key={"TICK" + index} tick={tick} count={ticks.length} labels={tickLabels} />
              ))}
            </div>
          )}
        </Ticks>
      </Slider>
    </div>
  );
}
